<script lang="ts">
import { Character, characterStore, initCharacter } from "../character/character";


	import { LocalStore } 	 from "./localstore";

	const localstore: LocalStore<Character> = new LocalStore<Character>("character");

	let savestates: Character[] = localstore.load();
	let character: Character;
	
	function loadInitialCharacter(){
		if(savestates.length == 0){
			return initCharacter()
		}
		return savestates[savestates.length - 1]
	}

	characterStore.set(loadInitialCharacter());


	function remove(chara: Character){
		const i = savestates.indexOf(chara)
		savestates.splice(i,1)
		savestates = savestates
		localstore.save(savestates)
	}

	function clone(char:Character){
		let newChar = JSON.parse(JSON.stringify(char))
		
		newChar.id = crypto.randomUUID()
		add(newChar)
	
	}

	function add(char: Character){
		savestates = localstore.load()

		savestates.push(char)
		localstore.save(savestates)

		characterStore.set(char)

		console.log("Save.add characterStore.set", char)

	}

	function update(char: Character){
		if(character == undefined) 
			return;

		savestates = savestates
			.map(n => n.id == char.id ? char : n)
		localstore.save(savestates)
	}
	
	characterStore.subscribe(char => {
		console.log("Save.subscibe", char)
		character = char
		update(character)
	});
	
</script>

<save>
	<h2>Savestates <a class="text-green-500 hover:text-green-700"on:click={() => add(initCharacter())}>+</a></h2>

		<ul>
			{#each savestates as save, i}
				<li class="flex flex-row { savestates.indexOf(character) == i ? "text-blue-300": "" }">
					<a class="hover:text-gray-200 text-lg"on:click={() => characterStore.set(save)}>
						{save.profession.name} {save.commonAttributes.name} [{save.level.level}]
					</a>

					<a on:click={() => clone(save)} class="px-2">
						<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000">
							<path d="M0 0h24v24H0z" fill="none" />
							<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
						</svg>
					</a>
		
					<a on:click={() => remove(save)} class="text-red-500 hover:text-red-700">
						X
						
						<!--<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000">
							<path d="M0 0h24v24H0z" fill="none" />
							<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
						</svg>-->
					</a>

		
				</li>
			
			{/each}

		</ul>


</save>

<style>
</style>
